import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { Flex, Group, Text } from "@mantine/core";
import type { JSX } from "react";
import { useRapportBuildingStore } from "../../../sales-tools/rapport-building/useRapportBuildingStore";
import { CustomerTime } from "./CustomerTime";
import { getLocationString } from "./getLocationString";
import { LocationIcon } from "./LocationIcon";

export function CustomerLocation(): JSX.Element | null {
    const { location, hasLocation } = useRapportBuildingStore();
    const {
        features: { isRapportEnabled },
    } = useFeatures<WorkspaceFeatures>();

    if (!isRapportEnabled || !hasLocation() || location == null) {
        return null;
    }

    return (
        <Flex align="center" gap="xs" data-testid="customer-location">
            <LocationIcon />
            <Group gap="3xs">
                <Text fz="sm" c="dark.0" data-testid="customer-location-text">
                    {getLocationString(location)}
                </Text>
                <CustomerTime location={location} />
            </Group>
        </Flex>
    );
}
